import React, { useContext, useEffect, useRef, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MenuItem from "@material-ui/core/MenuItem";
import Collapse from "@material-ui/core/Collapse";
import Menu from "@material-ui/core/Menu";
import ButtonBase from "@material-ui/core/ButtonBase";
import FiltroData from "../FiltroData";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import AddIcon from "@material-ui/icons/Add";
import FilterListIcon from "@material-ui/icons/FilterList";
import StarIcon from "@material-ui/icons/Star";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import Button from "@material-ui/core/Button";
import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsList";
import TabPanel from "../TabPanel";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import TicketsQueueSelect from "../TicketsQueueSelect";
import api from "../../services/api";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";
import { poderDeAdmin } from "../../utils/perfil";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.type === "dark" ? "#131917" : "#f7faf8",
    color: theme.palette.text.primary,
  },

  topToolbar: {
    display: "flex",
    alignItems: "center",
    padding: "12px 16px",
    gap: 6,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
    '@media (max-width: 600px)': {
      padding: '8px 8px',
      gap: 4,
    },
  },
  searchBox: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#f3f7f4",
    borderRadius: 12,
    padding: "5px 12px",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "#e3ece6"}`,
    transition: "border-color .2s ease, box-shadow .2s ease, background-color .2s ease",
    "& svg": { color: "#1E9855" },
    "&:focus-within": {
      borderColor: "#1E9855",
      backgroundColor: theme.palette.background.paper,
      boxShadow: "0 0 0 3px rgba(30,152,85,0.15)",
    },
  },
  searchInput: {
    flex: 1,
    border: "none",
    backgroundColor: "transparent",
    color: theme.palette.text.primary,
    fontSize: 13,
  },
  toolbarIcon: {
    padding: 8,
    color: theme.palette.text.secondary,
    borderRadius: 10,
    transition: "all .2s ease",
    "&:hover": {
      color: "#1E9855",
      backgroundColor: "rgba(30,152,85,0.10)",
      transform: "translateY(-1px)",
    },
  },

  mainTabs: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "#e9f1ec",
    borderRadius: 12,
    margin: "12px 16px 8px 16px",
    minHeight: 44,
    padding: 4,
    flexShrink: 0,
    // aba principal selecionada = pílula verde cheia
    "& .MuiTabs-indicator": {
      height: "100% !important",
      borderRadius: 10,
      background: "linear-gradient(135deg, #16a34a, #22c55e) !important",
      boxShadow: "0 4px 12px rgba(34,197,94,0.30)",
      zIndex: 1,
    },
    "& .Mui-selected": { color: "#ffffff !important" },
    '@media (max-width: 600px)': {
      margin: '8px 8px 4px 8px',
      minHeight: 38,
    },
  },
  mainTab: {
    minHeight: 36,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14,
    padding: "0 12px",
    color: theme.palette.text.secondary,
    zIndex: 2,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  mainTabBadge: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: 12,
    padding: "2px 10px",
    fontSize: 12,
    fontWeight: 700,
    marginLeft: 8,
    // dentro da pílula verde selecionada o contador fica translúcido
    ".Mui-selected &": { backgroundColor: "rgba(255,255,255,0.25)" },
  },
  mainTabBadgeSecondary: {
    ".Mui-selected &": { backgroundColor: "rgba(255,255,255,0.25)", color: "#ffffff" },
    backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[800] : theme.palette.grey[300],
    color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.text.secondary,
    borderRadius: 12,
    padding: "2px 10px",
    fontSize: 12,
    fontWeight: 700,
    marginLeft: 8,
  },

  subTabBadge: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: 10,
    padding: "2px 6px",
    fontSize: 10,
    fontWeight: 700,
    marginLeft: 6,
  },
  subTabBadgeSecondary: {
    // Mesmo laranja da bolinha "cliente na fila" no menu lateral
    // (CORES_BOLINHA.ia em layout/MainListItems.js). O azul do contador de
    // "precisa de humano" ao lado ja segue a mesma logica.
    backgroundColor: "#f59e0b",
    color: "#fff",
    borderRadius: 10,
    padding: "2px 6px",
    fontSize: 10,
    fontWeight: 700,
    marginLeft: 6,
  },

  subTabBadgeHumano: {
    backgroundColor: "#2563eb",
    color: "#fff",
    borderRadius: 10,
    padding: "2px 6px",
    fontSize: 10,
    fontWeight: 700,
    marginLeft: 4,
  },

  subTabs: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#eef4f0",
    borderRadius: 12,
    margin: "0 16px 12px 16px",
    minHeight: 40,
    padding: 3,
    flexShrink: 0,
    "& .MuiTabs-indicator": {
      height: "100% !important",
      borderRadius: 10,
      backgroundColor: `${theme.palette.type === "dark" ? "rgba(34,197,94,0.16)" : "#ffffff"} !important`,
      border: theme.palette.type === "dark" ? "1px solid rgba(74,222,128,0.35)" : "1px solid #cfe7d8",
      boxShadow: theme.palette.type === "dark" ? "none" : "0px 2px 6px rgba(16,40,28,0.08)",
      zIndex: 1,
    },
    '@media (max-width: 600px)': {
      margin: '0 8px 8px 8px',
      minHeight: 34,
    },
  },
  subTab: {
    minHeight: 34,
    textTransform: "none",
    fontWeight: 500,
    fontSize: 13,
    minWidth: 80,
    padding: "0 10px",
    color: theme.palette.text.secondary,
    zIndex: 2,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },

  

  filtersPanel: {
    padding: "12px 14px 14px",
    backgroundColor: theme.palette.type === "dark"
      ? "rgba(255,255,255,0.02)"
      : "#fbfcfd",
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
      padding: '8px',
    },
  },
  filtroTituloLinha: {
    gridColumn: "1 / -1",
    fontSize: "0.66rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: theme.palette.text.secondary,
    marginBottom: 2,
  },
  filtroAcoes: {
    gridColumn: "1 / -1",
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 2,
  },
  collapseWrapper: {
    flexShrink: 0,
  },
  filterControl: {
    "& .MuiInputBase-root": {
      borderRadius: 8,
      fontSize: 13,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiOutlinedInput-input": {
      padding: "9px 12px",
    },
    "& .MuiInputLabel-root": {
      fontSize: 12.5,
    },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
      transform: "translate(12px, 11px) scale(1)",
    },
  },

  // ---- pilulas de filtro (substituem os Select com seta) ----
  pilula: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    width: "100%",
    padding: "7px 10px",
    borderRadius: 999,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    fontSize: 12.5,
    fontWeight: 500,
    textTransform: "none",
    cursor: "pointer",
    transition: "all .15s ease",
    minWidth: 0,
    "&:hover": {
      borderColor: "#1E9855",
      backgroundColor:
        theme.palette.type === "dark"
          ? "rgba(30,152,85,.08)"
          : "rgba(30,152,85,.05)",
    },
  },
  pilulaAtiva: {
    borderColor: "#1E9855",
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(30,152,85,.16)"
        : "rgba(30,152,85,.10)",
    color: "#1E9855",
    fontWeight: 600,
  },
  pilulaIcone: {
    fontSize: 15,
    flexShrink: 0,
  },
  pilulaTexto: {
    flex: 1,
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  pilulaLimpar: {
    fontSize: 14,
    flexShrink: 0,
    opacity: 0.75,
    "&:hover": { opacity: 1 },
  },
  menuFiltro: {
    "& .MuiPaper-root": {
      borderRadius: 10,
      marginTop: 4,
      maxHeight: 300,
      minWidth: 190,
      boxShadow: "0 8px 24px rgba(16,24,40,.14)",
    },
    "& .MuiMenuItem-root": {
      fontSize: 13,
      paddingTop: 7,
      paddingBottom: 7,
    },
    "& .Mui-selected": {
      backgroundColor: "rgba(30,152,85,.12) !important",
      color: "#1E9855",
      fontWeight: 600,
    },
  },

  badge: {
    right: "-10px",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },
}));

/**
 * Botao-pilula que abre um menu de opcoes.
 *
 * Substitui o <Select> outlined: a seta do MUI ficava desalinhada dentro da
 * borda arredondada e o label flutuante brigava com o placeholder quando o
 * valor era vazio. Aqui o proprio botao ja mostra o que esta selecionado, e um
 * "x" limpa sem precisar abrir o menu.
 */
const PilulaFiltro = ({ classes, icone, rotulo, valor, opcoes, onChange }) => {
  const [ancora, setAncora] = useState(null);

  const selecionada = opcoes.find((o) => String(o.id) === String(valor));
  const ativo = !!selecionada;

  return (
    <>
      <ButtonBase
        className={`${classes.pilula} ${ativo ? classes.pilulaAtiva : ""}`}
        onClick={(e) => setAncora(e.currentTarget)}
      >
        {icone}
        <span className={classes.pilulaTexto}>
          {selecionada ? selecionada.nome : rotulo}
        </span>
        {ativo ? (
          <CloseIcon
            className={classes.pilulaLimpar}
            onClick={(e) => {
              e.stopPropagation();
              onChange("");
            }}
          />
        ) : (
          <ExpandMoreIcon className={classes.pilulaIcone} />
        )}
      </ButtonBase>

      <Menu
        className={classes.menuFiltro}
        anchorEl={ancora}
        open={!!ancora}
        onClose={() => setAncora(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          selected={!valor}
          onClick={() => {
            onChange("");
            setAncora(null);
          }}
        >
          <em>Todos</em>
        </MenuItem>
        {opcoes.map((o) => (
          <MenuItem
            key={o.id}
            selected={String(o.id) === String(valor)}
            onClick={() => {
              onChange(o.id);
              setAncora(null);
            }}
          >
            {o.nome}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

// A aba escolhida vive no navegador de quem esta atendendo.
//
// Sem isto, todo F5 jogava a pessoa de volta em "Abertos / Meus": quem
// finalizava um atendimento, ia para Finalizados conferir e recarregava a
// pagina, se via em outra aba sem entender por que. A aba e uma escolha do
// atendente, e escolha de quem usa nao se desfaz sozinha.
const CHAVE_ABAS = "atendimentos:abas";

const lerAbasSalvas = () => {
  try {
    const bruto = window.localStorage.getItem(CHAVE_ABAS);
    if (!bruto) return {};
    const salvo = JSON.parse(bruto);
    return salvo && typeof salvo === "object" ? salvo : {};
  } catch (e) {
    // Navegador com armazenamento bloqueado (aba anonima, politica da
    // empresa): segue com o padrao, sem quebrar a tela.
    return {};
  }
};

const TicketsManager = () => {
  const classes = useStyles();
  const escuro = useTheme().palette.type === "dark";
  // Estilo do indicador das abas direto no elemento (inline): pela classe ele
  // continuava aparecendo como um sublinhado fino.
  const indicadorPrincipal = {
    style: {
      height: "100%",
      borderRadius: 10,
      background: "linear-gradient(135deg, #16a34a, #22c55e)",
      boxShadow: "0 4px 12px rgba(34,197,94,0.30)",
      zIndex: 1,
    },
  };
  const indicadorSecundario = {
    style: {
      height: "100%",
      borderRadius: 10,
      backgroundColor: escuro ? "rgba(34,197,94,0.16)" : "#ffffff",
      border: escuro ? "1px solid rgba(74,222,128,0.35)" : "1px solid #cfe7d8",
      boxShadow: escuro ? "none" : "0 2px 6px rgba(16,40,28,0.08)",
      boxSizing: "border-box",
      zIndex: 1,
    },
  };

  const [searchParam, setSearchParam] = useState("");
  const [mainTab, setMainTab] = useState(() => lerAbasSalvas().mainTab || "open");
  const [subTab, setSubTab] = useState(() => lerAbasSalvas().subTab || "mine");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const searchInputRef = useRef();
  const { user } = useContext(AuthContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [allCount, setAllCount] = useState(0);
  const [closedCount, setClosedCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);

  // Admin e operador enxergam todos os atendimentos (aba "Vendedores" e a
  // lista da I.A completa). O operador precisa disso para acompanhar os
  // clientes que travaram na formalizacao e transferir para quem for preciso.
  const isAdmin = poderDeAdmin(String(user.profile || "").toLowerCase());

  // "Todos" so existe para admin. Se um usuario perdeu o perfil desde a ultima
  // visita, a aba salva apontaria para uma aba que nao esta mais na tela.
  useEffect(() => {
    // Aba da I.A tambem e so de admin/operador.
    if (!isAdmin && (subTab === "all" || subTab === "pending")) setSubTab("mine");
  }, [isAdmin, subTab]);

  useEffect(() => {
    try {
      window.localStorage.setItem(
        CHAVE_ABAS,
        JSON.stringify({ mainTab, subTab })
      );
    } catch (e) {
      /* armazenamento indisponivel: a aba so nao sobrevive ao F5 */
    }
  }, [mainTab, subTab]);

  const [tags, setTags] = useState([]);
  const [queues, setQueues] = useState([]);
  const [whatsapps, setWhatsapps] = useState([]);
  const [users, setUsers] = useState([]);

  const [filterTag, setFilterTag] = useState("");
  const [filterQueue, setFilterQueue] = useState("");
  const [filterWhatsapp, setFilterWhatsapp] = useState("");
  const [filterUser, setFilterUser] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filterFavorite, setFilterFavorite] = useState(false);

  useEffect(() => {
    const loadFilters = async () => {
      try {
        const [tagsRes, queuesRes, whatsRes, usersRes] = await Promise.all([
          api.get("/tags").catch(() => ({ data: [] })),
          api.get("/queue").catch(() => ({ data: [] })),
          api.get("/whatsapp").catch(() => ({ data: [] })),
          api.get("/users").catch(() => ({ data: { users: [] } })),
        ]);
        setTags(Array.isArray(tagsRes.data) ? tagsRes.data : []);
        setQueues(Array.isArray(queuesRes.data) ? queuesRes.data : []);
        setWhatsapps(Array.isArray(whatsRes.data) ? whatsRes.data : []);
        setUsers(Array.isArray(usersRes.data?.users) ? usersRes.data.users : (Array.isArray(usersRes.data) ? usersRes.data : []));
      } catch (err) {
        
      }
    };
    loadFilters();
  }, []);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();
    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam("");
      return;
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
    }, 500);
  };

  
  const [humanoCount, setHumanoCount] = useState(0);
  // Laranja da aba I.A = so quem esta COM a assistente (mesma conta da barra
  // lateral). Antes usava o total da lista "pending", que inclui quem ja
  // precisa de humano: 2 com a IA + 30 esperando humano apareciam como 32.
  const [esperaCount, setEsperaCount] = useState(0);

  
  const [filtroPeriodo, setFiltroPeriodo] = useState({ from: "", to: "" });

  useEffect(() => {
    let vivo = true;

    const buscar = async () => {
      try {
        const { data } = await api.get("/tickets/contadores");
        if (vivo) {
          setHumanoCount(data.humano || 0);
          setEsperaCount(data.espera || 0);
        }
      } catch {
        
      }
    };

    buscar();
    const socket = openSocket();
    socket.on("ticket", buscar);
    socket.on("aiNotification", buscar);
    const aplicarContadores = data => {
      if (!vivo || !data) return;
      setHumanoCount(data.humano || 0);
      setEsperaCount(data.espera || 0);
    };
    socket.on("ticketCounters", aplicarContadores);

    return () => {
      vivo = false;
      socket.off("ticket", buscar);
      socket.off("aiNotification", buscar);
      socket.off("ticketCounters", aplicarContadores);

      

    };
  }, []);


  const applySubTabStyle = (target) => {
    if (subTab !== target) {
      return { width: 0, height: 0 };
    }
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={() => setNewTicketModalOpen(false)}
      />

      {}
      <div className={classes.topToolbar}>
        <div className={classes.searchBox}>
          <SearchIcon style={{ color: "#999", fontSize: 20, marginRight: 4 }} />
          <InputBase
            className={classes.searchInput}
            placeholder={i18n.t("tickets.search.placeholder")}
            type="search"
            onChange={handleSearch}
            inputRef={searchInputRef}
          />
        </div>
        <Tooltip title="Novo ticket">
          <IconButton className={classes.toolbarIcon} onClick={() => setNewTicketModalOpen(true)}>
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Filtros avançados">
          <IconButton
            className={classes.toolbarIcon}
            onClick={() => setShowFilters((prev) => !prev)}
            style={showFilters ? { color: "#5b5fc7" } : {}}
          >
            <FilterListIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Favoritos">
          <IconButton 
            className={classes.toolbarIcon}
            onClick={() => setFilterFavorite((prev) => !prev)}
            style={filterFavorite ? { color: "#ffc107" } : {}}
          >
            <StarIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        {}
        {false && (
          <TicketsQueueSelect
            style={{ marginLeft: 2 }}
            selectedQueueIds={selectedQueueIds}
            userQueues={isAdmin ? queues : user?.queues}
            onChange={(values) => setSelectedQueueIds(values)}
          />
        )}
      </div>

      {}
      <Collapse in={showFilters} className={classes.collapseWrapper}>
        <div className={classes.filtersPanel}>
          <div className={classes.filtroTituloLinha}>Filtrar por</div>

          <PilulaFiltro
            classes={classes}
            icone={<LocalOfferIcon className={classes.pilulaIcone} />}
            rotulo="Etiquetas"
            valor={filterTag}
            opcoes={tags.map((t) => ({ id: t.id, nome: t.name }))}
            onChange={setFilterTag}
          />

          <PilulaFiltro
            classes={classes}
            icone={<WhatsAppIcon className={classes.pilulaIcone} />}
            rotulo="Conexões"
            valor={filterWhatsapp}
            opcoes={whatsapps.map((w) => ({ id: w.id, nome: w.name }))}
            onChange={setFilterWhatsapp}
          />

          {isAdmin && (
            <PilulaFiltro
              classes={classes}
              icone={<PersonOutlineIcon className={classes.pilulaIcone} />}
              rotulo="Atendentes"
              valor={filterUser}
              opcoes={users.map((u) => ({ id: u.id, nome: u.name }))}
              onChange={setFilterUser}
            />
          )}

          {}
          <div style={{ gridColumn: "1 / -1" }}>
            <FiltroData value={filtroPeriodo} onChange={setFiltroPeriodo} />
          </div>

          <div className={classes.filtroAcoes}>
            <Button
              size="small"
              variant="text"
              color="default"
              onClick={() => {
                setFilterTag("");
                setFilterQueue("");
                setFilterWhatsapp("");
                setFilterUser("");
                setFilterDate("");
                setFiltroPeriodo({ from: "", to: "" });
              }}
              style={{ borderRadius: 8, minWidth: 78 }}
            >
              Limpar
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              disableElevation
              onClick={() => {
                setShowFilters(false);
              }}
              style={{ borderRadius: 8, minWidth: 92 }}
            >
              Aplicar
            </Button>
          </div>
        </div>
      </Collapse>

      {}
      <Tabs
        value={mainTab}
        onChange={(e, v) => setMainTab(v)}
        className={classes.mainTabs}
        TabIndicatorProps={indicadorPrincipal}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab
          value="open"
          className={classes.mainTab}
          label={
            <span>
              Em andamento
              <span className={classes.mainTabBadge}>
                {isAdmin ? allCount + pendingCount : openCount}
              </span>
            </span>
          }
        />
        <Tab
          value="closed"
          className={classes.mainTab}
          label={
            <span>
              Finalizados
              <span className={classes.mainTabBadgeSecondary}>{closedCount}</span>
            </span>
          }
        />
      </Tabs>

      {}
      {searchParam ? (
        <div className={classes.ticketsWrapper} style={{ flex: 1 }}>
          {}
          <TicketsList
            searchParam={searchParam}
            showAll={true}
            mostrarOcultos="true"
            selectedQueueIds={selectedQueueIds}
            filterTag={filterTag}
            filterQueue={filterQueue}
            filterWhatsapp={filterWhatsapp}
            filterUser={filterUser}
            filterDate={filterDate}
                dateFrom={filtroPeriodo.from}
                dateTo={filtroPeriodo.to}
            filterFavorite={filterFavorite.toString()}
          />
        </div>
      ) : (
        <>
          {}
          <TabPanel value={mainTab} name="open" className={classes.ticketsWrapper} style={{ flex: 1 }}>
            {}
            <Tabs
              value={subTab}
              onChange={(e, v) => setSubTab(v)}
              className={classes.subTabs}
              TabIndicatorProps={indicadorSecundario}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab
                value="mine"
                className={classes.subTab}
                label={
                  <span>
                    Meus
                    <span className={classes.subTabBadge}>{openCount}</span>
                  </span>
                }
              />
              {isAdmin && (
                <Tab
                  value="all"
                  className={classes.subTab}
                  label={
                    <span>
                      Vendedores
                      <span className={classes.subTabBadge}>{allCount}</span>
                    </span>
                  }
                />
              )}
              {isAdmin && (
              <Tab
                value="pending"
                className={classes.subTab}
                label={
                  <span>
                    I.A
                    <span
                      title={`${esperaCount} com a assistente`}
                      className={classes.subTabBadgeSecondary}
                    >
                      {esperaCount}
                    </span>
                    {}
                    {humanoCount > 0 && (
                      <span
                        title={`${humanoCount} precisando de atendimento humano`}
                        className={classes.subTabBadgeHumano}
                      >
                        {humanoCount}
                      </span>
                    )}
                  </span>
                }
              />
              )}
            </Tabs>

            <Paper className={classes.ticketsWrapper}>
              {}
              <TicketsList
                status="open"
                showAll={false}
                selectedQueueIds={selectedQueueIds}
                updateCount={(val) => setOpenCount(val)}
                style={applySubTabStyle("mine")}
                filterTag={filterTag}
                filterQueue={filterQueue}
                filterWhatsapp={filterWhatsapp}
                filterUser={filterUser}
                filterDate={filterDate}
                dateFrom={filtroPeriodo.from}
                dateTo={filtroPeriodo.to}
                filterFavorite={filterFavorite.toString()}
              />

              {}
              {isAdmin && (
                <TicketsList
                  status="open"
                  showAll={true}
                  selectedQueueIds={selectedQueueIds}
                  updateCount={(val) => setAllCount(val)}
                  style={applySubTabStyle("all")}
                  filterTag={filterTag}
                  filterQueue={filterQueue}
                  filterWhatsapp={filterWhatsapp}
                  filterUser={filterUser}
                  filterDate={filterDate}
                dateFrom={filtroPeriodo.from}
                dateTo={filtroPeriodo.to}
                  filterFavorite={filterFavorite.toString()}
                />
              )}

              {}
              {isAdmin && (
              <TicketsList
                status="pending"
                selectedQueueIds={selectedQueueIds}
                updateCount={(val) => setPendingCount(val)}
                style={applySubTabStyle("pending")}
                showAll={isAdmin}
                filterTag={filterTag}
                filterQueue={filterQueue}
                filterWhatsapp={filterWhatsapp}
                filterUser={filterUser}
                filterDate={filterDate}
                dateFrom={filtroPeriodo.from}
                dateTo={filtroPeriodo.to}
                filterFavorite={filterFavorite.toString()}
              />
              )}
            </Paper>
          </TabPanel>

          {}
          <div
            className={classes.ticketsWrapper}
            style={{ flex: 1, display: mainTab === "closed" ? "flex" : "none", flexDirection: "column" }}
          >
            <TicketsList
              status="closed"
              showAll={true}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setClosedCount(val)}
              filterTag={filterTag}
              filterQueue={filterQueue}
              filterWhatsapp={filterWhatsapp}
              filterUser={filterUser}
              filterDate={filterDate}
                dateFrom={filtroPeriodo.from}
                dateTo={filtroPeriodo.to}
              filterFavorite={filterFavorite.toString()}
            />
          </div>
        </>
      )}
    </Paper>
  );
};

export default TicketsManager;
